import { api } from "../lib/api";

export const getFile = (messageId, attachmentId) =>
  api
    .get(
      `/mail/messages/${encodeURIComponent(messageId)}/attachments/${encodeURIComponent(attachmentId)}`,
      {
        responseType: "blob",
      }
    )
    .then((response) => response.data);
